module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-5-aa0f97231bb0dfda68836c1141c7660f.webp";